export default __webpack_public_path__ + "static/media/moped.3db49cac.svg";